import Widgets from 'flarum/extensions/afrux-forum-widgets-core/common/extend/Widgets';
import UpcomingEventsWidget from './components/UpcomingEventsWidget';

export default function (app) {
  new Widgets()
    .add({
      key: 'upcomingEvents',
      component: UpcomingEventsWidget,
      isDisabled: false,
      isUnique: true,
      placement: 'start',
      position: 0,
    })
    .extend(app, 'kemze-upcoming-events-widget');
}
